import { render, staticRenderFns } from "./PositionAccess.vue?vue&type=template&id=43cfc1b0&"
import script from "./PositionAccess.vue?vue&type=script&lang=js&"
export * from "./PositionAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports